import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlugin2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPlugin2"><Path d="M2.5 7.5H21.5V19.5H2.5V7.5Z" stroke="currentColor"/><Path d="M4.5 7.5V3.5H10.5V7.5" stroke="currentColor" strokeLinecap="square"/><Path d="M13.5 7.5V3.5H19.5V7.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPlugin2;
